<template>
	<div>
        <loading ref="loading"></loading>
        <div class="login-container" v-if="isAlreadyLoading">
            <Header></Header>
            <div class="banner">
                <img src="@/assets/images/signin_banner.jpg" alt="pic">
            </div>
            <div class="form-content">
                <div class="content-notice">
                    <p>您尝试查看的页面需要登录</p>
                    <p>IHG<span class="sup">®</span>Rewards Club优悦会会员账号</p>
                    <p>请先登录再进行查看</p>
                </div>
                <div class="warning-box" v-show="isErrorNoticeShow">
                    <div class="warning-img-box">
                        <img class="warning-icon" src="@/assets/images/warning.png" alt="pic">
                    </div>
                    <p v-html="errorNotice"></p>
                </div>
                <div class="user-box">
                    <div v-show="isLastnameShow" class="lastname-box" :style="{marginBottom: isErrorOfNameShow||isErrorOfLatinNameShow ? '24px' : '14px'}">
                        <div class="input-box name-box">
                            <input type="text" placeholder="中文姓氏" class="weui-input" v-model="userLastname" @blur="validateLastname" v-on:change="translateLastName" maxlength="35"/>
                            <span class="error-message" v-show="isErrorOfLastname">{{errorOfLastname}}</span>
                        </div>
                        <div class="input-box name-box">
                            <input type="text" placeholder="姓氏用拼音输入" class="weui-input" v-model="userLatinLastname" @blur="validateLatinLastname" maxlength="35"/>
                            <span class="error-message" v-show="isErrorOfLatinLastname">{{errorOfLatinLastname}}</span>
                        </div>
                    </div>
                    <div class="input-box" :style="{marginBottom: isErrorOfAccountShow ? '24px' : '14px'}">
                        <input type="text" class="weui-input" placeholder="电子邮箱或会员号" v-model="userAccount" @blur="validateAccount"/>
                        <span class="error-message" v-show="isErrorOfAccount">{{errorOfAccount}}</span>
                    </div>
                    <div class="input-box" :style="{marginBottom: isErrorOfPinShow ? '24px' : '14px'}">
                        <input type="tel"  style="-webkit-text-security:disc" class="weui-input" placeholder="密码" maxlength="4" v-model="userPinCode" @blur="validatePin"/>
						<span class="error-message" v-show="isErrorOfPin">{{errorOfPin}}</span>
                    </div>
                </div>
                <div class="retire-pin">
                    <a href="https://www.ihg.com/hotels/cn/zh/customer-care/forms/retrieve-pin" class="retire-pin-link">找回密码</a>
                </div>
                <div class="button-box">
                    <button :disabled="isLogin" class="login-button" @click="submitForLogin()">登 录</button>
                </div>
            </div>
            <div class="switch-content">
                <div class="content-notice">
                    <p>还不是IHG<span class="sup">®</span>Rewards Club会员？</p>
                    <p>免费注册，手续简便。</p>
                </div>
                <div class="switch-box">
                    <button class="switch-button" @click="goEnrollment">立即加入</button>
                </div>
            </div>
        </div>
	</div>
</template>

<script type="text/javascript">
import { getPinYinTranslation, sendLoginFrom, getCsrfToken } from "@/api/index";
import { setStorage, getStorage } from '@/alias/store';
import MtaH5 from 'mta-h5-analysis';
import loading from "@/components/loading";
import Header from "@/components/Header";
export default{
	name: 'sign-in',
	data(){
		return {
            isAlreadyLoading: false,
            isLastnameShow: false,
            userAccount: '',
            userPinCode: '',
            errorOfAccount: '',
			errorOfPin: '',
			isErrorOfPin: false,
            isErrorOfAccount: false,
            isErrorOfAccountShow: false,
            isErrorOfPinShow: false,
            errorOfLastname: '',
            userLastname: '',
            userLatinLastname: '',
            isErrorOfLastname: false,
            isErrorOfNameShow: false,
            isErrorOfLatinLastname: false,
            isErrorOfLatinNameShow: false,
            errorOfLatinLastname: '',
            flag: true,
            errorNotice: '',
            isErrorNoticeShow: false,
            csrfToken: ''
		}
    },
    components: {
        loading,
        Header
    },
    computed: {
        isLogin: function() {
            let userAccount = false;
            const reg =  /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_]{3,6}$)+/;
            const reg_number = /^\d{9}$/;
            const reg_pin = /^\d{4}$/;
            const reg_lastname = /^([a-zA-Z\u4e00-\u9fa5 ]+|[a-zA-Z\u4e00-\u9fa5 ]+)$/;
            const reg_latinname = /^([a-zA-Z ]+)$/;

            if(reg_number.test(this.userAccount)) {
                userAccount = true;
            }else if(reg.test(this.userAccount)) {
                userAccount = true;
            }else {
                userAccount = false;
            }
            if(!this.flag) {
                let _isdisabled = userAccount && reg_pin.test(this.userPinCode) && reg_lastname.test(this.userLastname) && reg_latinname.test(this.userLatinLastname);
                this.flag = _isdisabled ? true : false
                return  _isdisabled ? false : true;
            } else {
                return userAccount && reg_pin.test(this.userPinCode) ? false : true;
            }
        }
    },
    methods: {
        validateAccount() {
            const reg =  /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_]{3,6}$)+/;
            const reg_number = /^\d{9}$/;

            if(this.userAccount === '') {
                this.isErrorOfAccountShow = true;
                this.isErrorOfAccount = true;
                this.errorOfAccount = '请输入电子邮箱或会员号码';
            }else if(this.userAccount.indexOf('@') === -1) {
                if(!reg_number.test(this.userAccount)) {
                    this.isErrorOfAccountShow = true;
                    this.isErrorOfAccount = true;
                    this.errorOfAccount = '输入的邮箱或会员号码格式有误';
                }else {
                    this.isErrorOfAccountShow = false;
                    this.isErrorOfAccount = false;
                }
            } else if(!reg.test(this.userAccount)) {
                this.isErrorOfAccountShow = true;
                this.isErrorOfAccount = true;
                this.errorOfAccount = '输入的邮箱地址格式有误';
            }else{
                this.isErrorOfAccountShow = false;
                this.isErrorOfAccount = false;
            }
        },
        goEnrollment() {
            MtaH5.clickStat('go_enrollment_from_signin')
            this.$router.push({
                name: 'SignUp'
            })
        },
        submitForLogin: async function() {

            this.$refs.loading.isLoading = true;

            let params = {
                'lastNameLatin': this.userLatinLastname || '',
                'pin': this.userPinCode,
                'userName': this.userAccount,
                'wxMpUser': JSON.parse(sessionStorage.getItem('userInfo'))
            }

            let res = await sendLoginFrom(params, this.csrfToken);
            if(this.flag && res.statusCode == 417) {
                this.isLastnameShow = true;
                this.isErrorNoticeShow = true;
                this.errorNotice = res.message;
                this.userPinCode = '';
                this.flag = false;
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                this.toGetCsrfToken();
            } else if(this.flag && res.statusCode === 0) {
                this.isLastnameShow = false;
                this.isErrorNoticeShow = false;
                window.location.assign(res.redirectUrl);
            } else if(this.flag && res.statusCode === 1){
                let userProfile = res.data.memberProfileData;
                let ssoToken = res.data.ssoTokenInfoData;
                setStorage('ssoToken', JSON.stringify(ssoToken));
                MtaH5.clickStat('signin_success')

                this.$router.replace({
                    name: 'Profile',
                    params: {
                        userProfile : userProfile,
                        isFromSignin: true
                    }
                })
            } else {
                this.toGetCsrfToken();
                this.isErrorNoticeShow = true;
                this.errorNotice = res.message;
                this.isLastnameShow = false;
                this.flag = true;
                this.userPinCode = '';
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            }

            this.$refs.loading.isLoading = false;
        },
		validatePin() {
            const reg = /^\d{4}$/;

			if(this.userPinCode === '') {
				this.isErrorOfPin = true;
                this.isErrorOfPinShow = true;
				this.errorOfPin = '请输入密码';
			} else if (!reg.test(this.userPinCode)) {
                this.isErrorOfPin = true;
                this.isErrorOfPinShow = true;
				this.errorOfPin = '输入的密码格式有误';
            } else {
                this.isErrorOfPinShow = false
				this.isErrorOfPin = false;
			}
		},
        validateLastname() {
            const reg =  /^([a-zA-Z\u4e00-\u9fa5 ]+|[a-zA-Z\u4e00-\u9fa5 ]+)$/;

            if(this.userLastname === '') {
                this.isErrorOfLastname = true;
                this.isErrorOfNameShow = true;
                this.errorOfLastname = '请输入您的中文姓氏';
            } else if(!reg.test(this.userLastname)) {
                this.isErrorOfLastname = true;
                this.isErrorOfNameShow = true;
                this.errorOfLastname = '请输入您正确的姓氏';
            } else {
                this.isErrorOfNameShow = false;
                this.isErrorOfLastname =false;
            }
        },
        validateLatinLastname() {
            const reg = /^([a-zA-Z ]+)$/;
            if(this.userLatinLastname === '') {
                this.isErrorOfLatinNameShow = true;
                this.isErrorOfLatinLastname = true;
                this.errorOfLatinLastname = '请输入您的姓氏拼音';
            } else if(!reg.test(this.userLatinLastname)) {
                this.isErrorOfLatinNameShow = true;
                this.isErrorOfLatinLastname = true;
                this.errorOfLatinLastname = '请输入正确的姓氏拼音';
            } else {
                this.isErrorOfLatinNameShow =false;
                this.isErrorOfLatinLastname = false;
            }
        },
        translateLastName: async function() {
            const reg =  /^([a-zA-Z\u4e00-\u9fa5 ]+|[a-zA-Z\u4e00-\u9fa5 ]+)$/;
            if(reg.test(this.userLastname) || this.userLastname == '') {
                let param = { "text" : this.userLastname };
                let res = await getPinYinTranslation(param);
                this.userLatinLastname = res.translation;
            }
            const reg_latin = /^([a-zA-Z ]+)$/;
            if(this.userLatinLastname !== '') {
                this.isErrorOfLatinNameShow = reg_latin.test(this.userLatinLastname) ? false : true;
                return this.isErrorOfLatinLastname = reg_latin.test(this.userLatinLastname) ? false : true;
            }
        },
        toGetCsrfToken: async function() {
            this.csrfToken = await getCsrfToken();
        }
    },
    mounted() {
        MtaH5.pgv();
        MtaH5.clickStat('signintoprofile',{'signinpage':'true'});
        MtaH5.clickStat('sintosuptopro',{'signinpage':'true'});
        this.toGetCsrfToken();
        if(document.getElementById("loading").style.display === 'block') {
            this.$refs.loading.isLoading = false;
        } else {
            this.$refs.loading.isLoading = true;
        }
        localStorage.removeItem('data');
        setTimeout(() => {
            this.$refs.loading.isLoading = false;
            document.getElementById("loading").style.display = 'none';
            this.isAlreadyLoading = true;
        }, 500);

        window.addEventListener("popstate", function(e) {
            let len = window.history.length;
            window.history.go(1-len);
        }, false);
    },

}
</script>

<style scope lang="sass">
html,body
    height: 100vh;
    background: #efefef;
.login-container
    background: #efefef;
    .banner
        width: 100%;
        img
            height: 120px;
            width: 100%;
    .content-notice
        font-size: 15px;
        color: #898c8b;
        text-align: center;
        line-height: 27px;
        .sup
            vertical-align: 2px;
            font-size: 12px;
            margin-right: 6px;
    .form-content
        width: 90%;
        margin: 18px auto;
        .warning-box
            padding: 9px;
            margin-top: 15px;
            background: #fff;
            border: 1px solid #c6c0ba;
            border-radius: 5px;
            .warning-img-box
                text-align: center;
                .warning-icon
                    width: 10%;
            p
                color: #d71920;
                font-size: 16px;
                font-weight: 600;
                line-height: 30px;
        .lastname-box
            position: relative;
        .error-message
            font-size: 14px;
            position: absolute;
            width: 100%;
            left: 0;
            top: 45px;
            color: red;
        .user-box
            width: 100%;
            margin-top: 22px;
            .input-box
                margin-bottom: 14px;
                padding: 0 2%;
                border: 1px solid #ccc;
                border-radius: 5px;
                background: #fff;
                position: relative;
                input
                    width: 96%;
                    height: 45px;
                    border: 0;
            .name-box
                width: 44%;
                margin-right: 1%;
                margin-bottom: 0;
                display: inline-block;
                &:nth-child(2)
                    margin-right: 0;
                input
                    height: 45px;
        .retire-pin
            margin: 5px 0 36px;
            text-align: right;
            .retire-pin-link
                color: #d26932;
                border-bottom: 1px solid #d98a61;
        .button-box
            width: 58%;
            margin: 0 auto;
            .login-button
                width: 100%;
                height: 45px;
                font-size: 18px;
                color: #fff;
                font-weight: 600;
                border-radius: 25px;
                background: #d26932;
                border: 0;
                outline: none;
            .login-button:disabled
                background: #b3b2b2;
    .switch-content
        width: 90%;
        margin: 0 auto;
        .switch-box
            width: 58%;
            margin: 0 auto;
            padding: 20px 0 40px;
            .switch-button
                width: 100%;
                height: 45px;
                font-size: 18px;
                color: #d26932;
                font-weight: 600;
                border-radius: 25px;
                background: transparent;
                border: 1px solid #d26932;
                outline: none;
span.error_message.help.is-danger
    font-size: 14px;
    margin-left: -5px;
</style>



// WEBPACK FOOTER //
// src/views/SignIn.vue